import React from "react";
import { InputNumber, Space, Typography } from "antd";
import FloatLabel from "./FloatLabel";
import { GRAY5, GRAY_PLACEHOLDER } from "../../constant/colors";

const { Text } = Typography;

const CustomInputNumber = ({ children, style = {}, required = false, bordered = false, ...props }) => {
  return (
    <FloatLabel
      label={
        <Space size={4}>
          {required && <Text style={{ color: GRAY_PLACEHOLDER }}>*</Text>}
          <Text style={{ color: GRAY_PLACEHOLDER }}>{props.label}</Text>
        </Space>
      }
      name={props.label}
      value={props.value}
    >
      <InputNumber
        {...props}
        bordered={bordered}
        style={
          !bordered
            ? {
                width: "100%",
                border: "0px",
                borderRadius: "0",
                borderBottom: `1px solid ${GRAY5}`,
                padding: props.label ? "7px 0 0px 0" : "",
                ...style
              }
            : style
        }
      >
        {children}
      </InputNumber>
    </FloatLabel>
  );
};

export { CustomInputNumber };
